import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ActivityLogEntry } from '../../../../../../../../../models/activity-log';
import { ActivityLogService } from '../../../../../../../../../services/activity-log/activity-log.service';

@Component({
  selector: 'app-customer-note-modal',
  templateUrl: './edit-activity-log-entry-notes-modal.component.html',
  styleUrls: ['./edit-activity-log-entry-notes-modal.component.css']
})
export class EditActivityLogEntryNotesModalComponent implements OnInit {

  @Input() entry: ActivityLogEntry;
  @Input() savedCallback: (successMessage: string) => undefined;

  public notes = '';

  public loadingSubmit = false;
  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    private activityLogService: ActivityLogService
  ) {}

  ngOnInit() {
    this.notes = this.entry.notes;
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.activityLogService
      .editActivityLogEntryNotes(
        this.entry.id,
        this.notes
      )
      .then(() => {
        this.savedCallback('Notes updated successfully.');
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit activity log notes.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
